<div class="flex justify-center items-center">
  <div
    class="my-5 w-full max-w-lg bg-white rounded-lg border border-border-100"
  >
    <div class="px-6 py-4 border-b border-border-100">
      <h1 class="text-lg font-semibold text-text-900">Resumo</h1>
    </div>

    <div class="px-16">
      <div class="py-4 border-b border-border-100">
        <div class="flex gap-4 items-center mb-3">
          <img src="person-icon.svg" alt="User Icon" class="w-8 h-8" />
          <h2 class="text-lg font-semibold text-text-950">Cliente</h2>
        </div>

        <div class="mb-3 ml-12">
          <span class="block text-xs text-text-900">Nome</span>
          <p class="text-sm font-semibold text-text-900">
            {{ customer?.name }}
          </p>
        </div>

        <div class="mb-3 ml-12">
          <span class="block text-xs text-text-900">CPF</span>
          <p class="text-sm font-semibold text-text-900">
            {{ customer?.cpf }}
          </p>
        </div>

        <div class="ml-12">
          <span class="block text-xs text-text-900">Endereço</span>
          <p class="text-sm font-semibold text-text-900">
            {{ getUserCompleteAddress() }}
          </p>
        </div>
      </div>
    </div>

    <div class="px-16">
      <div class="py-4 border-b border-border-100">
        <div class="flex gap-4 items-center mb-3">
          <img src="physician-icon.svg" alt="Dentist Icon" class="w-8 h-8" />
          <h2 class="text-lg font-semibold text-text-950">Dentista</h2>
        </div>

        <div class="ml-12">
          <p class="text-sm font-semibold text-text-950">
            {{ physician?.name }}
          </p>
          <p class="mb-2 text-sm text-text-700">CRO {{ appointment?.CRO }}</p>
        </div>
      </div>
    </div>

    <div class="px-16 py-4">
      <div class="flex gap-4 items-center mb-3">
        <img src="clock-icon.svg" alt="Clock Icon" class="w-8 h-8" />
        <h2 class="text-lg font-semibold text-text-950">Agendamento</h2>
      </div>
      <div class="ml-12">
        <div class="grid grid-cols-12 items-center w-full gap-4">
          @if (appointmentDate) {
            <div class="flex flex-col gap-2 col-span-10">
              <app-progress-bar
                [value]="coupon?.remainingDays || 0"
                [maxDays]="coupon?.expirationDays || 30"
              />
              <p class="text-sm font-semibold text-text-900">
                {{ appointmentDate | date: 'dd/MM/yyyy' }} às
                {{ appointmentDate | date: 'HH:mm' }}
              </p>
            </div>
            <app-tooltip
              content="Editar agendamento"
              position="top"
              class="col-span-2"
            >
              <app-icon-button
                icon="edit_calendar"
                [size]="24"
                [textColor]="'text-black'"
                (handleClick)="editAppointment()"
                [disabled]="isCanceled"
              />
            </app-tooltip>
          }
        </div>
        <p class="mt-2 text-sm text-text-700">
          {{ getPhysicianCompleteAddress() }}
        </p>
      </div>
    </div>

    <div class="px-16 py-4">
      <div class="flex gap-4 items-center mb-3">
        <img src="attach-money.svg" alt="Money Icon" class="w-8 h-8" />
        <h2 class="text-lg font-semibold text-text-950">Procedimentos</h2>
      </div>
      @if (coupon) {
        <div class="flex flex-col gap-3 ml-12">
          <div class="pb-4 border-b border-border-100">
            @for (
              procedure of selectedProcedures;
              track procedure.procedureId;
              let idx = $index
            ) {
              <div class="flex gap-2 justify-between mb-1">
                <span class="text-sm text-text-900">
                  {{ procedure.procedureName }}
                </span>
                <span class="text-sm text-text-900">
                  {{ convertToBrazilianCurrency(procedure.procedurePrice) }}
                </span>
              </div>
            }
          </div>

          <div class="mt-3">
            <div class="flex justify-between mb-2 text-sm">
              <span class="text-text-900">Total dos procedimentos</span>
              <span class="text-text-700">
                R$ {{ proceduresTotal | number: '1.2-2' }}
              </span>
            </div>

            <div class="flex justify-between items-center mb-2 text-sm">
              <span class="text-text-900">Total de descontos</span>
              <div class="flex gap-2 items-center">
                <span
                  class="px-2 py-1 text-xs font-medium text-white rounded bg-background-700"
                >
                  {{ discountPercent | number: '1.0-2' }}%
                </span>
                <span class="font-medium text-red-600">
                  -R$ {{ discountTotal | number: '1.2-2' }}
                </span>
              </div>
            </div>

            <div class="flex justify-between mb-2 text-sm">
              <span class="text-text-900">Serviço</span>
              <span class="text-text-700">
                R$ {{ serviceTax | number: '1.2-2' }}
              </span>
            </div>

            <div class="my-3 w-full h-px bg-border-100"></div>

            <div
              class="flex justify-between text-base font-semibold text-text-900"
            >
              <span>Total</span>
              <span> R$ {{ finalPrice | number: '1.2-2' }} </span>
            </div>
          </div>
        </div>
      } @else {
        <app-alert
          title="Aguardando compra"
          message="O paciente ainda não realizou a compra de procedimentos"
        />
      }
    </div>

    @if (paymentLink && !(coupon?.isAssigned || isCanceled)) {
      <div class="px-16 py-4">
        <div class="flex gap-4 items-center mb-3">
          <img src="attach-money.svg" alt="Money Icon" class="w-8 h-8" />
          <h2 class="text-lg font-semibold text-text-950">Pagamento</h2>
        </div>

        <div class="flex justify-between">
          <div class="flex flex-col gap-2 ml-12">
            <p class="text-sm font-semibold text-text-900">Link de pagamento</p>
            <p class="text-sm text-text-700">{{ paymentLink }}</p>
          </div>

          <div class="flex gap-2">
            <app-tooltip content="Copiar link" position="top">
              <app-icon-button
                icon="content_copy"
                [size]="24"
                [textColor]="'text-black'"
                (handleClick)="copyLink()"
              />
            </app-tooltip>
            <app-tooltip content="Reenviar link" position="top">
              <app-icon-button
                icon="refresh"
                [size]="24"
                [textColor]="'text-black'"
                (handleClick)="resendLink()"
              />
            </app-tooltip>
          </div>
        </div>
      </div>
    }

    @if (isPaid && couponQRCode && !coupon?.isAssigned) {
      <div class="px-16 py-4">
        <div class="flex gap-4 items-center mb-3">
          <img src="attach-money.svg" alt="Money Icon" class="w-8 h-8" />
          <h2 class="text-lg font-semibold text-text-950">QR Code</h2>
        </div>

        <div class="flex flex-col gap-6 ml-12">
          <app-alert
            class="mt-6"
            message="Cupom válido para qualquer dentista em nossa rede."
          />
          <div class="w-full">
            <app-progress-bar
              [value]="coupon?.remainingDays || 0"
              [maxDays]="coupon?.expirationDays || 30"
              height="12px"
            />
            <div class="flex justify-between mt-2">
              <div class="flex flex-col gap-1">
                <p class="text-sm text-text-900">Adquirido</p>
                <p class="text-sm font-semibold text-text-900">
                  {{ coupon?.createdAt | date: 'dd/MM/yyyy' }}
                </p>
              </div>
              <div class="flex flex-col gap-1">
                <p class="text-sm text-text-900">Vencimento</p>
                <p class="text-sm font-semibold text-text-900">
                  {{ coupon?.expireAt | date: 'dd/MM/yyyy' }}
                </p>
              </div>
            </div>

            <div class="flex flex-col gap-2">
              <img [src]="couponQRCode" alt="QR Code" class="my-4 w-full" />
              <p class="text-sm font-medium text-text-700">ID DO CUPOM</p>
              <p class="text-sm font-medium text-text-900">
                {{ coupon?.id }}
              </p>
            </div>
          </div>
        </div>
      </div>
    }

    <div class="px-14 py-8">
      <div class="grid grid-cols-2 gap-3 justify-end">
        <app-button
          label="Voltar"
          [buttonType]="
            coupon?.isAssigned || isCanceled ? 'solid' : 'secondary'
          "
          buttonAction="default"
          (handleClick)="goBack()"
          fullSize="true"
        />
        @if (!coupon?.isAssigned && !isCanceled) {
          <app-button
            [label]="labelButtonCancelPurchase"
            buttonType="solid"
            buttonAction="negative"
            (handleClick)="openCancelPurchaseModal()"
            fullSize="true"
          />
        }
      </div>
    </div>
  </div>
</div>

<app-modal
  [visible]="appointmentModalVisible"
  (visibleChange)="appointmentModalVisible = $event"
  [title]="'Agendamento'"
  [width]="'420px'"
  [closeOnEscape]="true"
  (close)="closeAppointmentModal()"
>
  <div class="flex flex-col gap-4 mt-10" [formGroup]="formAppointment">
    <app-calendar formControlName="appointmentDateTime" />
    <div class="grid grid-cols-2 gap-2 mt-6 w-full">
      <app-button
        label="Cancelar"
        buttonType="secondary"
        buttonAction="default"
        (handleClick)="closeAppointmentModal()"
        fullSize="true"
      />
      <app-button
        label="Salvar"
        buttonType="solid"
        buttonAction="default"
        (handleClick)="saveAppointment()"
        fullSize="true"
        [disabled]="formAppointment.invalid"
      />
    </div>
  </div>
</app-modal>

<app-modal
  [visible]="displayModal"
  (visibleChange)="displayModal = $event"
  [title]="labelButtonCancelPurchase"
  [width]="'480px'"
  [closeOnEscape]="true"
  [footerTemplate]="confirmFooterTemplate"
>
  <p class="px-1 py-5 text-text-700">
    Você tem certeza de que deseja {{ isPaid ? 'estornar' : 'cancelar' }}
    {{ coupon ? 'está compra' : 'este agendamento' }}? Essa ação não pode ser
    desfeita.
  </p>
</app-modal>

<ng-template #confirmFooterTemplate>
  <div class="flex gap-2 justify-end">
    <app-button
      label="Cancelar"
      buttonType="secondary"
      buttonAction="default"
      (handleClick)="displayModal = false"
      fullSize="true"
    />
    <app-button
      [label]="labelButtonCancelPurchase"
      buttonType="solid"
      buttonAction="negative"
      (handleClick)="cancelPurchase()"
    />
  </div>
</ng-template>
